import { SurveyAreaAutocomplete } from 'components/survey-area-autocomplete';
import type { ReferenceLocationResponse } from 'types/api-responses';
import { useCategoryFields } from '../template-hooks';
import type { FilterTemplateProps } from '../../types';
import style from '../filter-modal.module.scss';

// The survey_area filter matches reference_locations.name exactly, so the
// selected suggestion's name is what we send. The full response object is kept
// only to render the current selection; an applied filter seeds it by name.
const SurveyAreaField = ({
  field,
  formValues,
  onFormChange,
}: {
  field: { id: string; label: string; param: string; placeholder?: string };
  formValues: Record<string, unknown>;
  onFormChange: (key: string, value: unknown) => void;
}) => {
  // Derive the current selection straight from the applied value so a chip
  // trash / Clear / Reset (which set pendingFilters.survey_area = undefined)
  // clears the combobox too. Local state would go stale on those external edits.
  const applied = formValues[field.param] as string | undefined;
  const selected = applied
    ? ({ name: applied } as ReferenceLocationResponse)
    : undefined;

  return (
    <SurveyAreaAutocomplete
      id={`filter-${field.id}`}
      titleText={field.label}
      placeholder={field.placeholder ?? ''}
      searchMinChars={2}
      location={{ value: selected, state: 'stable' }}
      onChange={({ selectedItem }) => {
        onFormChange(field.param, selectedItem?.name || undefined);
      }}
    />
  );
};

export const SurveyAreaTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const fields = useCategoryFields(category, 'survey-area');

  return (
    <div className={style.fieldStack}>
      {fields.map((field) => (
        <SurveyAreaField
          key={field.id}
          field={field}
          formValues={formValues}
          onFormChange={onFormChange}
        />
      ))}
    </div>
  );
};
